import API from 'services/TAPS_API';

export default function getProfileAddressDetailed() {
  return API.request({
    method: 'GET',
    url: '/profile/addressDetailed',
  });
}
